import React, { useEffect, useState } from "react";
import classes from "./FileVersion.module.css";
import { useAppDispatch, useAppSelector } from "../../../app/hooks/hooks";
import {
    useGetAllUserFilesQuery,
    useSetActiveVersionMutation,
} from "../../../app/services/files/files";
import { selectUser } from "../../../app/features/auth/authSlice";
import { Models } from "@prisma/client";
import { setAlert } from "../../../app/features/alertSlice/alertSlice";
import { useNavigate } from "react-router-dom";
interface FileVersionsProps {
    currentFile: Models;
    close: () => void;
    update: () => void;
}
function FileVersions({ currentFile, close, update }: FileVersionsProps) {
    const currentUser = useAppSelector(selectUser);
    const [setActiveVersion] = useSetActiveVersionMutation();
    const [selectedState, setSelectedState] = useState<Models[]>([]);
    const files = useGetAllUserFilesQuery(currentUser?.id);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const versions: any[] = [];
    files.currentData?.forEach((row) => {
        if (currentFile.model_name === row.model_name) {
            versions.push(row);
        }
    });
    const getDate = (load_date: Date) => {
        const curDate = new Date(load_date);
        const dd =
            curDate.getDate() > 9
                ? `${curDate.getDate()}`
                : `0${curDate.getDate()}`;
        const mm =
            curDate.getMonth() + 1 > 9
                ? `${curDate.getMonth() + 1}`
                : `0${curDate.getMonth() + 1}`;
        const yy = curDate.getFullYear();
        return `${dd}.${mm}.${yy}`;
    };
    const compareClickHandle = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        e.preventDefault();
        e.stopPropagation();
        if (selectedState[0]?.model_id && selectedState[1]?.model_id) {
            sessionStorage.setItem(
                "model_paths",
                JSON.stringify(
                    selectedState
                        .sort((a, b) => a.version - b.version)
                        .map(
                            (version) =>
                                `Users/${currentUser?.id}/${version.model_id}.min.bmt`
                        )
                )
            );
            navigate("/compareViewer");
        } else {
            dispatch(
                setAlert({
                    message: "Select 2 vesrions to compare!",
                    type: "error",
                })
            );
        }
    };
    return (
        <div
            className={classes.contextWrap}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                close();
            }}
            onMouseMove={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <div
                className={classes.modalWrap}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setSelectedState([]);
                }}
            >
                <button
                    onClick={compareClickHandle}
                    className={classes.compareBut}
                >
                    compare
                </button>
                <div className={classes.headerWrap}>
                    <div>File name</div>
                    <div>Size </div>
                    <div>Date</div>
                    <div>Active</div>
                </div>
                {versions.map((file: Models) => (
                    <div
                        className={[
                            classes.rowWrap,
                            selectedState[0]?.model_id === file.model_id ||
                            selectedState[1]?.model_id === file.model_id
                                ? classes.selected
                                : "",
                        ].join(" ")}
                        key={file.model_id}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setSelectedState((ex) => {
                                let arr: Models[] = [];
                                if (ex.length) {
                                    if (ex[0]?.model_id === file.model_id) {
                                        arr = [ex[1]];
                                    } else if (
                                        ex[1]?.model_id === file.model_id
                                    ) {
                                        arr = [ex[0]];
                                    } else {
                                        arr[0] = ex[1] ? ex[1] : ex[0];
                                        arr[1] = file;
                                    }
                                } else {
                                    arr[0] = file;
                                }
                                return arr;
                            });
                        }}
                    >
                        <div>{`${file.model_name} v${file.version}`}</div>
                        <div>
                            {Math.round((file.size / 1024 / 1024) * 100) / 100}
                            Mb
                        </div>
                        <div>{getDate(file.load_date)}</div>
                        <input
                            className={[classes.activeInput].join(" ")}
                            type="checkbox"
                            checked={file.active}
                            onChange={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                setActiveVersion(file.model_id).then(() => {
                                    dispatch(
                                        setAlert({
                                            message: "Active version selected!",
                                            type: "success",
                                        })
                                    );
                                    update();
                                });
                            }}
                        ></input>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default FileVersions;
